const state = () => ({
    allSelected: {},
})

const mutations = {
    setAllSelected(state, {grid, selected}) {
        state.allSelected[grid] = selected
    }
}

export default {
    state,
    mutations
}
